import React from 'react'
import s from './styles/CheckBox.module.scss'
import { ReactComponent as CheckIcon } from '../../../assets/icons/check.svg'

const CheckBox = ({
	isSelected,
	onToggle = () => {},
	className = '',
	classNameLabel = '',
	variant = 'square',
	disabled = false,
}) => {
	const handleChange = e => {
		e.stopPropagation()
		if (disabled) return
		onToggle(e)
	}

	return (
		<label
			className={`${s.wrap} ${classNameLabel} ${s[variant]} ${disabled ? s.disabled : ''}`.trim()}
			onClick={e => e.stopPropagation()}
		>
			<input
				type="checkbox"
				checked={isSelected}
				onChange={handleChange}
				disabled={disabled}
			/>
			<span className={`${s.checkbox} ${className}`} aria-hidden="true">
				<CheckIcon className={s.icon} />
			</span>
		</label>
	)
}

export default CheckBox
